export const HARDWARE_TYPES = {
  DECODER: 'decoder',
  ENCODER: 'encoder',
} as const;

export const SORT_HARDWARE_TYPES = {
  ASC: 'asc',
  DESC: 'desc',
} as const;
